/**
 * Download CTA (Large) — lightweight cover-image carousel.
 *
 * Self-contained (no jQuery / Slick dependency). Fades between slides,
 * supports prev/next arrows, dot navigation and autoplay that pauses
 * on hover. Multiple instances per page are supported.
 */
(function () {
  "use strict";

  function initCarousel(root) {
    var track = root.querySelector(".download-cta__slides");
    var slides = Array.prototype.slice.call(
      root.querySelectorAll(".download-cta__slide")
    );
    if (!track || slides.length < 2) {
      return;
    }

    var dots = Array.prototype.slice.call(
      root.querySelectorAll("[data-dl-dot]")
    );
    var prev = root.querySelector("[data-dl-prev]");
    var next = root.querySelector("[data-dl-next]");

    var current = 0;
    var timer = null;
    var INTERVAL = 5000;

    function goTo(index) {
      index = (index + slides.length) % slides.length;

      if (dots[current]) {
        dots[current].classList.remove("is-current");
      }
      slides[current].classList.remove("is-current");

      current = index;

      // Slide the track horizontally.
      track.style.transform = "translateX(" + -current * 100 + "%)";

      slides[current].classList.add("is-current");
      if (dots[current]) {
        dots[current].classList.add("is-current");
      }
    }

    function nextSlide() {
      goTo(current + 1);
    }

    function prevSlide() {
      goTo(current - 1);
    }

    function startAuto() {
      stopAuto();
      timer = window.setInterval(nextSlide, INTERVAL);
    }

    function stopAuto() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (next) {
      next.addEventListener("click", function () {
        nextSlide();
        startAuto();
      });
    }

    if (prev) {
      prev.addEventListener("click", function () {
        prevSlide();
        startAuto();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        goTo(parseInt(dot.getAttribute("data-dl-dot"), 10) || 0);
        startAuto();
      });
    });

    root.addEventListener("mouseenter", stopAuto);
    root.addEventListener("mouseleave", startAuto);

    startAuto();
  }

  function init() {
    var carousels = document.querySelectorAll("[data-dl-carousel]");
    Array.prototype.forEach.call(carousels, initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
